import React, { Component } from "react";
import AdminTools from './AdminTools.js';
import AdminMap from './AdminMap.js';
import App from '../App.js';
import '../css/AdminApp.css';

class AdminApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.selectPort = this.selectPort.bind(this);
        this.getPortData = this.getPortData.bind(this);
        this.selectPOI = this.selectPOI.bind(this);
        this.getPOIData = this.getPOIData.bind(this);

    }

    componentDidMount() {
        let serverUrl = 'http://localhost:9000/';
        if (process.env.NODE_ENV === 'development') serverUrl = 'http://localhost:9000/'
        else if (process.env.NODE_ENV === 'production') serverUrl = window.location.protocol + '//' + window.location.host + '/';

        this.setState({ serverUrl: serverUrl }, this.isLogged);

        // this.loadData();
    }
    render() {
        return (

            <div id="AdminApp">
                {this.state.AdminLoggedIn == true ?
                    <>
                        <AdminTools boats={this.state.boats} users={this.state.users} ports={this.state.ports} selectedPort={this.state.selectedPort} getPortData={this.getPortData} POIs={this.state.POIs} selectedPOI={this.state.selectedPOI} getPOIData={this.getPOIData} />
                        <AdminMap boats={this.state.boats} ports={this.state.ports} selectPort={this.selectPort} POIs={this.state.POIs} selectPOI={this.selectPOI} />
                    </>
                    :
                    <>
                        <>Not connected</>
                    </>
                }
            </div>
        );
    }

    isLogged() {
        const options = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include'
        }
        console.log(this.state.serverUrl + 'auth/check')
        fetch(this.state.serverUrl + 'auth/check', options)
            .then(
                res => res.json().then(json => {
                    console.log(json)
                    if (json.message === 'success') {
                        if (json.admin) {
                            const getBoatDataBound = this.getBoatData.bind(this);
                            this.setState({ AdminLoggedIn: true, getBoatDataClock: setInterval(getBoatDataBound, 1000) }, this.loadData);


                        }
                        console.log('success')
                    } else {
                        console.log('not success')
                    }
                })
            )
            .catch(err => (console.log(err)));
    }

    loadData() {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        }
        // console.log(this.props.serverUrl)
        fetch(this.state.serverUrl + 'admin/data', options)
            .then(res => res.json().then(json => {
                this.setState({ boats: json.boats, users: json.users, ports: json.ports, POIs: json.POIs })
            }))
            .catch(err => console.log(err));

    }

    selectPort(portId) {
        this.setState({ selectedPort: portId });
    }
    selectPOI(POI_ID) {
        this.setState({ selectedPOI: POI_ID });
    }

    getBoatData() {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        }
        // console.log(this.props.serverUrl)
        fetch(this.state.serverUrl + 'admin/boats', options)
            .then(res => res.json().then(json => {
                if (json.boats && !json.error) {
                    this.setState({ boats: json.boats })
                }
            }))
            .catch(err => console.log(err));
    }

    getPortData() {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        }
        fetch(this.state.serverUrl + 'admin/ports', options)
            .then(res => res.json().then(json => {
                if (json.ports && !json.error) {
                    this.setState({ ports: json.ports })
                }
            }))
            .catch(err => console.log(err));
    }

    getPOIData() {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        }
        console.log('up poi')
        fetch(this.state.serverUrl + 'admin/pois', options)
            .then(res => res.json().then(json => {
                if (json.POIs && !json.error) {
                    this.setState({ POIs: json.POIs })
                }
            }))
            .catch(err => console.log(err));
    }
}


export default AdminApp;
